import React, {Component} from "react"
import {ApolloError} from "apollo-boost"

import id from "@irati/utils/id"
import {Recognition as RecognitionField} from "@irati-web/fields/poll/votes"
import {validatedScreen} from "@irati/utils/validation"
import {commentSchema} from "@irati-web/fields/poll/votes/validation"
import {ValidationButton, Hidden} from "@irati/ui/src/FormItem"
import ErrorText from "@irati/ui/src/ErrorText"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import CreateCommentMutation from "@irati/recognition/apollo/mutation/Comment/Create"
import {FeedItem} from "@irati/types"
import tracking from "@irati-tracking/recognition/shared"
import {Form} from "../layouts"

interface Props extends InjectIntl {
  id: string,
  item: FeedItem,
  inputRef: () => void
}

interface State {
  message: string
}

class CreateComment extends Component<Props, State> {
  state: State = {
    message: ""
  }

  static defaultProps = {
    id: "leave-comment",
    inputRef: () => {}
  }

  handleChange = (message: string) => this.setState({
    message
  })

  handleCommentCreationComplete = () => {
    tracking.commentPollAndRecognition()
  }

  handleCommentCreationError = (response: ApolloError) => {
    tracking.errorsComment(response)
  }

  render() {
    const {item, intl, inputRef} = this.props
    const {message} = this.state
    const hasComments = item.comments.results.length > 0
    const fieldProps = hasComments ? {
      autoFocus: false
    } : {
      autoFocus: true
    }

    return (
      <CreateCommentMutation
        item={item}
        message={message}
        onCompleted={this.handleCommentCreationComplete}
        onError={this.handleCommentCreationError}>
        {(onClick, apolloState) => (
          <Form>
            <RecognitionField
              onChange={this.handleChange}
              value={message}
              placeholder={intl.formatMessage({id: "recognition.popup.shared.comments.placeholder"})}
              inputRef={inputRef}
              {...fieldProps} />
            <Hidden
              name="hidden-recognition"
              value={message}
              validation={commentSchema(intl)} />
            {apolloState.error && (
              <div>
                <ErrorText>
                  {apolloState.errorMsg}
                </ErrorText>
              </div>
            )}
            <ValidationButton
              id={id("submit", this.props)}
              onClick={onClick}
              apolloState={apolloState}
              full
              primary>
              <FormattedMessage id="recognition.popup.shared.comments.comment" />
            </ValidationButton>
          </Form>
        )}
      </CreateCommentMutation>
    )
  }
}

export default injectIntl(validatedScreen(CreateComment, "CreateComment"))
